import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { SectionTitle } from "../../atoms/SectionTitle";

export const Wrapper = styled.div`
    background-color: ${colors.brandMid};
    margin-top: 16px;

    ${breakpoints.medium} {
        margin-top: 0;
    }
`;

export const Inner = styled.div`
    padding: 50px 0;
    overflow: hidden;
`;

export const Title = styled(SectionTitle)`
    color: white;
    margin: -8px 0 40px;

    ${breakpoints.medium} {
        margin: 0 0 32px 0;
    }
`;
